import { DutyActivity, Trip, Workday, User } from '../../models/workday';
import { FC, Fragment } from 'react';
import { formatTime } from '../../utils/dateTime';
import { Box, Divider, List } from '@mui/material';
import { RowData, CollapsibleList } from '../CollapsibleList/CollapsibleList';
import { RouteCard } from './RouteCard';
import { InfoCard, InfoCardContent } from '../InfoCard/InfoCard';
import {
  BlockPrepCard,
  BlockPrepCardContent,
} from '../BlockPrepCard/BlockPrepCard';
import { IconType } from '../../enums/IconType';
import { addMinutes, isAfter } from 'date-fns';

type Props = {
  dutyActivity: DutyActivity;
  workday: Workday;
  user: User;
};

function getDateFromHours(time: any) {
  time = time.split(':');
  let now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...time);
}

const getVehicleText = (wd: Workday, da: DutyActivity, us: User) => {
  if (da.Trip[0]?.TrpVehicle === '') {
    return 'Fordon ej tursatt';
  }

  let vehicleTitle = '';

  const currentTime = addMinutes(new Date(), 15);
  const workDayStarts = getDateFromHours(da.DtyActStartTime);

  const workDayHasStartedOrStartsIn15Min = isAfter(currentTime, workDayStarts);

    if((!da.SignedIn && us.HideBusNumber && !us.IsSignedIn)){
    vehicleTitle = 'Signa in för att se fordonsnummer';
    }
    else{
      vehicleTitle = 'Fordon ' + da.Trip.flatMap((t) => t?.TrpVehicle)[0];
    }
    
  if(us.SignInFileOver11Min){
    vehicleTitle = 'Bussnummer har inte kommit från planeringssystemet';
  }

  return vehicleTitle;
};

export const Route: FC<Props> = ({ workday: wd, dutyActivity: da, user: us}) => (
  <RouteCard
    main={`Omlopp ${da.DtyActName}`}
    vehicle={`${getVehicleText(wd, da, us)}`}
    from={`${formatTime(da.DtyActStartTime)} - ${da.DtyActStartPlace}`}
    to={`${formatTime(da.DtyActEndTime)} - ${da.DtyActEndPlace} `}
    tripIsEu={da.Trip.some((trip: Trip) => trip.TripIsEu)}
  >
    {da.DtyActCommentary! && (
      <Box py={1}>
        <InfoCard>
          <InfoCardContent comment={da.DtyActCommentary} icon={IconType.Info} />
        </InfoCard>
      </Box>
    )}

    {da.Trip.length > 0 && (
      <BlockPrepCard>
        <BlockPrepCardContent da={da} isOutPrep={true} />
      </BlockPrepCard>
    )}
    <List>
      {da.Trip.map((trip, i) => {
        const points: RowData[] = trip.TripPoint.filter(
          (tp) => tp.IsWithinDuty,
        ).map((tp) => ({
          text: tp.StpDescription,
          icon: tp.StpDescription.toUpperCase().includes('DEPÅ')
            ? IconType.House
            : IconType.Stop,
          arrivalTime: tp.TrpptArrivalTime,
          departureTime: tp.TrpptDepartureTime,
          trpptFac: tp.TrpptFac,
          trpptTpNote: tp.TrpptTpNote,
          ttpNoteText: tp.TtpNoteText,
          serviceMessage: tp.TrpptServiceMessage,
          loadTime: tp.TrpptLoadTime,
        }));

        return (
          <Fragment key={trip.TrpNumber}>
            {i !== 0 && <Divider />}
            <CollapsibleList
              trip={trip}
              rows={[...points]}
              key={trip.TrpNumber}
            />
          </Fragment>
        );
      })}
    </List>
    {da.Trip.length > 0 &&
      (da.Trip.slice(-1)[0].TrpNextRoute || da.Trip.slice(-1)[0].BlkPrepIn) && (
        <BlockPrepCard>
          <BlockPrepCardContent da={da} isOutPrep={false} />
        </BlockPrepCard>
      )}
  </RouteCard>
);
